import { types } from '../../../constants/ActionTypes'
import { tokenSilentlyOption } from '../../../lib/Auth0'
import { getRootURL } from '../../../lib'

export const createdAuth0Client = (auth0) => ({
  type: types.auth0.CREATED_AUTH0_CLIENT,
  auth0
})

export const changedAuthState = (user) => ({
  type: types.auth0.CHANGED_AUTH_STATE,
  user
})

export const notifyLogin = () => (dispatch, getState) => {
  const auth0 = getState().authentication.auth0
  if (!auth0) return
  return auth0.getTokenSilently(tokenSilentlyOption)
  .then(accessToken => {
    return fetch(getRootURL() + '/user/login', {
      method: 'POST',
      headers: {
        "Content-Type": "application/json",
        Authorization: 'Bearer ' + accessToken
      }
    })
  })
  .catch(error => {
    console.dir(error)
  })    
}


// WEBPACK FOOTER //
// ./src/Parts/Auth0/actions/index.js